import { render } from "./HeroiconsOutlineLockClosed.vue?vue&type=template&id=5a9370b1"
const script = {}

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLockClosed.vue"]])

export default __exports__